import { render } from "./DialogPassChangeToValid.vue?vue&type=template&id=4426a4a7"
import script from "./DialogPassChangeToValid.vue?vue&type=script&lang=js"
export * from "./DialogPassChangeToValid.vue?vue&type=script&lang=js"
script.render = render

export default script